import { Layout as AntLayout } from 'antd';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Navbar } from './Navbar';
import { NavbarLoading, SidebarLoading } from '@src/components';
import clsx from 'clsx';
import { BottomMenu } from './BottomMenu';

const { Header } = AntLayout;

export function Layout() {
  return (
    <div className={clsx('flex h-full w-full', 'bg-wl-surface')}>
      <div className='flex w-full'>
        {/* Sidebar: Always visible on large screens, Drawer on mobile */}
        <div className='hidden md:block w-64'>
          <Suspense fallback={<SidebarLoading />}>
            <Sidebar />
          </Suspense>
        </div>

        <div className='flex flex-col flex-1 min-w-0'>
          <Header
            className={clsx(
              'h-24 md:h-16 px-4 sm:px-8 py-3 text-lg font-semibold flex items-center border-b border-wl-border',
              'bg-wl-surface'
            )}
          >
            <Suspense fallback={<NavbarLoading />}>
              <Navbar />
            </Suspense>
          </Header>

          {/* Content */}
          <div className='flex-1 p-8 max-sm:px-4 max-md:px-6 max-md:py-4 max-md:pb-20 overflow-auto'>
            <Outlet />
          </div>
        </div>

        <div className='sm:flex md:hidden fixed bottom-0 left-0 w-full transition-transform duration-300'>
          <BottomMenu />
        </div>
      </div>
    </div>
  );
}
